import { render, staticRenderFns } from "./PermissionCard.vue?vue&type=template&id=683c8345&scoped=true&"
import script from "./PermissionCard.vue?vue&type=script&lang=js&"
export * from "./PermissionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683c8345",
  null
  
)

export default component.exports